import React from 'react';
import { useModalContext } from '@/contexts/ModalContext';
import { ClientPoolStatus, PoolDetail, PoolStatus } from '@/types/pool';
import { getPoolStatus, hasCounterOffer } from '@/utils/poolStatus';
import { Button } from '../../ui/Button';

type PoolBorrowerActionsProps = {
  pool: PoolDetail;
  onDelete: () => void;
  onAcceptOffer: () => void;
  onRejectOffer: () => void;
  onAcceptCounterOffer: () => void;
  onRejectCounterOffer: () => void;
};

export const PoolBorrowerActions: React.FC<PoolBorrowerActionsProps> = ({
  pool,
  onDelete,
  onAcceptOffer,
  onRejectOffer,
  onAcceptCounterOffer,
  onRejectCounterOffer,
}) => {
  const { openPoolModal } = useModalContext();
  const status = getPoolStatus(pool.status, hasCounterOffer(pool.offers));

  const onEdit = () => {
    if (pool) {
      openPoolModal({ pool });
    }
  };

  const showEditButton = status === PoolStatus.SYSTEM_PENDING;
  const showOfferActions = status === PoolStatus.OFFER_RECEIVED;
  const showCounterOfferActions = status === ClientPoolStatus.COUNTER_OFFER_RECEIVED;
  const showClosePoolButton =
    status === PoolStatus.SYSTEM_PENDING ||
    status === PoolStatus.AWAITING_INVESTORS ||
    status === PoolStatus.OFFER_RECEIVED ||
    status === ClientPoolStatus.COUNTER_OFFER_RECEIVED;

  return (
    <div className="flex flex-col gap-2 items-center w-full">
      {showEditButton && (
        <Button onClick={onEdit} variant="primary">
          Edit
        </Button>
      )}
      {showOfferActions && (
        <div className="flex gap-2 items-center">
          <Button onClick={onAcceptOffer} variant="primary">
            Accept offer
          </Button>
          <Button onClick={onRejectOffer} variant="secondary">
            Reject offer
          </Button>
        </div>
      )}
      {showCounterOfferActions && (
        <div className="flex gap-2 items-center">
          <Button onClick={onAcceptCounterOffer} variant="primary">
            Accept a counter offer
          </Button>
          <Button onClick={onRejectCounterOffer} variant="secondary">
            Reject an investor request
          </Button>
        </div>
      )}
      {showClosePoolButton && (
        <Button onClick={onDelete} variant="dangerText">
          Close the pool
        </Button>
      )}
    </div>
  );
};
